export default function loadingModalService($uibModal) {
  'ngInject';
  var modalInstance = null;

  this.open = function (params) {

    modalInstance = $uibModal.open({
      animation: false,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./loading.modal.html'),
      windowClass: 'modal-centered-vertical',
      resolve: {
        params: params
      },
      controller: function ($scope, params) {
        $scope.params = params;
      },
      size: 'lg'
    });
  };

  this.close = function () {
    if (modalInstance) {
      modalInstance.dismiss('closed');
    }
  };
}